import { DashboardCards } from "@/features/clinician/dashboard/components/dashboard";

function Dashboard() {
    return (
        <>
            <div className="px-4 py-8">
                <div className="container mx-auto">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your dashboard
                    </h1>
                    <DashboardCards />
                </div>
            </div>
        </>
    );
}

export default Dashboard;
